import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'
import { getKioskDocument, getKioskWindow } from 'src/utils/helpers'

const ScrollToTop = props => {
  const location = useLocation()
  const kiosk_window = getKioskWindow()
  const kiosk_document = getKioskDocument()
  useEffect(() => {
    setTimeout(() => {
      if (props.isAppLoading) return
      const mainContent = kiosk_document.querySelector('.app-main-content')
      if (kiosk_document && mainContent) {
        mainContent.scrollTo(0, 0)
      }
      kiosk_window.scrollTo(0, 0)
    }, 0)
  }, [location, props.isAppLoading])

  return <>{props.children}</>
}

export default connect(state => ({
  isAppLoading: state.appReducer.isAppLoading,
}))(ScrollToTop)
